import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import Link from 'next/link'

import ROUTES from 'config/routes.json'
import content from 'prismic-translates/common.json'
import legalPages from 'prismic-translates/legal-pages.json'
import useCleanBackUrl from 'src/hooks/useCleanBackUrl'

const t = getTranslationFromJson([content, legalPages])

type Props = {
  onClick: () => void
}

function TermsCheckbox(props: Props) {
  const cleanBackUrl = useCleanBackUrl()

  return (
    <div data-test='checkbox-terms-label'>
      {t('terms_checkbox_text')}{' '}
      <Link
        href={`${ROUTES.TERMS}?back=${encodeURIComponent(cleanBackUrl)}#restricted`}
        prefetch={false}
        data-test='checkbox-terms-label-terms-restricted-link'
      >
        <span className='mt-link' onClick={props.onClick}>
          {t('restricted_territories')}
        </span>
      </Link>
      {t('dot')}
      <br />
      {t(`${process.env.BRAND_NAME}_by_creating`)}
      &nbsp;
      {t('i_agree')}
      &nbsp;
      <Link
        href={`${ROUTES.TERMS}?back=${encodeURIComponent(cleanBackUrl)}`}
        prefetch={false}
        data-test='checkbox-terms-label-terms-link'
      >
        <span className='mt-link' onClick={props.onClick}>
          {t('terms_of_use')}
        </span>
      </Link>
      &nbsp;
      {t(`${process.env.BRAND_NAME}_policies`)}
      &nbsp;
      <Link
        href={`${ROUTES.PRIVACY}?back=${encodeURIComponent(cleanBackUrl)}`}
        prefetch={false}
        data-test='checkbox-terms-label-privacy-link'
      >
        <span className='mt-link' onClick={props.onClick}>
          {t('privacy_policy')}
        </span>
      </Link>
      {t('dot')}
    </div>
  )
}

export default TermsCheckbox
